import { useCallback } from 'react'
import styled from 'styled-components'

import ModalProvider from 'contexts/ModalProvider'
import ModalBase from 'LuxKit/Modal/ModalBase'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import CartPanelContainer from '../containers/CartPanelContainer'
import { useMobileCartPanelState } from '../hooks/useMobileCartPanelState'

const MobileCartPanelModal = styled(ModalBase)`
  overflow: hidden;
`

const MobileCartPanelContent = styled.div`
  grid-column: first / last;
  grid-row: first / last;
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`

interface TripChatMobileCartPanelModalProps {
  onClose: () => void
}

function TripChatMobileCartPanelModal({ onClose }: TripChatMobileCartPanelModalProps) {
  const modalElement = useModalElementContext()
  return (
    <MobileCartPanelModal
      height="full"
      data-testid="trip-chat-mobile-cart-panel-layer"
      onClose={onClose}
    >
      <MobileCartPanelContent>
        <CartPanelContainer
          isClosing={modalElement.open === false}
          onClose={onClose}
        />
      </MobileCartPanelContent>
    </MobileCartPanelModal>
  )
}

interface TripChatMobileCartPanelHostProps {
  closeSignal?: number
  onCartOpenChange?: (isOpen: boolean) => void
}

function TripChatMobileCartPanelHostContent({ closeSignal, onCartOpenChange }: TripChatMobileCartPanelHostProps) {
  const createCartModal = useCallback((onClose: () => void) => (
    <TripChatMobileCartPanelModal onClose={onClose} />
  ), [])

  useMobileCartPanelState(createCartModal, closeSignal, onCartOpenChange)

  return null
}

function TripChatMobileCartPanelHost(props: TripChatMobileCartPanelHostProps) {
  return (
    <ModalProvider>
      <TripChatMobileCartPanelHostContent {...props} />
    </ModalProvider>
  )
}

export default TripChatMobileCartPanelHost
